import { type FC, useEffect } from 'react'

import { LoaderCircle } from '@skytech/ui'
import { useQuery } from '@tanstack/react-query'
import { useLocation } from 'react-router-dom'

import injuryreportResources from '@/api/injuryReports'
import queries from '@/api/queries'

import { Translation } from '../i18n/Translation'

import { AssetCard } from './AssetCard'

export const AssetList: FC = () => {
  const { state } = useLocation()
  const { data: assets, isLoading } = useQuery(
    queries.injuryReportAssets(),
    injuryreportResources.getAssetList
  )

  useEffect(() => {
    if (!assets || !state?.scrollToAssetId) return
    const el = document.getElementById(`asset-${state.scrollToAssetId}`)
    el?.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }, [assets, state?.scrollToAssetId])

  if (isLoading)
    return (
      <div className="flex justify-center">
        <LoaderCircle />
      </div>
    )

  if (assets?.length === 0)
    return (
      <p>
        <Translation id="Fant ikke noe utstyr." />
      </p>
    )

  return (
    <ul className="assets">
      {assets?.map(asset => (
        <AssetCard key={asset.id} {...asset} highlighted={asset.id === state?.scrollToAssetId} />
      ))}
    </ul>
  )
}
